/**
 * Accordion with image — scoped multi-open accordion toggle.
 */
(function () {
  'use strict';

  function initAccordionWithImageSection(section) {
    if (!section) return;

    section.querySelectorAll('.accordion-with-image__trigger').forEach(function (trigger) {
      if (trigger.dataset.accordionLoaded === 'true') return;
      trigger.dataset.accordionLoaded = 'true';

      trigger.addEventListener('click', function () {
        const item = this.closest('.accordion-with-image__item');
        const panel = this.nextElementSibling;
        if (!item || !panel) return;

        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.offsetHeight;

          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';

          panel.addEventListener(
            'transitionend',
            function () {
              if (item.classList.contains('is-open')) {
                panel.style.maxHeight = 'none';
              }
            },
            { once: true }
          );
        }
      });
    });
  }

  function boot() {
    document
      .querySelectorAll('[data-section-type="accordion-with-image"]')
      .forEach(initAccordionWithImageSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = document.querySelector(
      '[data-section-id="' + event.detail.sectionId + '"][data-section-type="accordion-with-image"]'
    );
    if (!section) return;

    section.querySelectorAll('.accordion-with-image__trigger').forEach(function (trigger) {
      delete trigger.dataset.accordionLoaded;
    });

    initAccordionWithImageSection(section);
  });
})();
